import DOMPurify from 'dompurify'

/**
 * Cleans CMS HTML before it goes into the page with `dangerouslySetInnerHTML`.
 * DOMPurify's defaults drop `<script>`, every `on*` handler and `javascript:` URLs.
 * Iframes stay, with the attributes a YouTube embed needs, and links keep their `target`.
 */
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'target']
  })
